import { MAX_ENTITIES_PER_PAGE } from 'src/pages/CatalogPage';

export type ResponseSubType = 'certification' | 'collection' | 'team_training' | 'learning_path' | 'course' | 'lesson';

export enum AtlenzContentType {
  lesson = 'lesson',
  course = 'course',
  'learning_path' = 'learningPath',
  collection = 'collection',
  certification = 'certification',
  'team_training' = 'instructorLedTraining',
}

export interface AtlenzResource {
  contentAri: string;
  title: string;
  slug: string;
  description: string;
  contentType: string;
  url: string;
  publishTo: string[];
  subType: ResponseSubType;
  level: string | null;
  duration: number;
  durationCategory: string;
  productKeys: string[];
  productPlatforms: string[];
}

export interface AtlenzCatalogResource {
  id: string;
  title: string;
  slug: string;
  description: string;
  type: AtlenzContentType;
  url: string;
  duration: number;
  deployment: Array<string>;
  product: Array<string>;
  productRole: Array<string>;
  __typename?: string;
}

export const getAtlenzCatalogResources = async (
  filters: Record<string, string[]>,
  startResourceNumber: number,
  searchValue?: string,
): Promise<AtlenzResponse | null> => {
  const body = {
    pagination: {
      from: startResourceNumber,
      size: MAX_ENTITIES_PER_PAGE,
    },
    ...filters,
    searchValue,
  };

  try {
    const response = await fetch(`${globalThis.location.origin}/gateway/api/learning-app/search`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    return response.json();
  } catch (error) {
    return null;
  }
};

export interface AtlenzResponse {
  pagination: { size: number; from: number };
  results: {
    content: AtlenzResource;
  }[];
}

export interface AtlenzCountersResponse {
  total: number;
  durationCounters: {
    [key: string]: number;
  };
  typeCounters: {
    [key: string]: number;
  };
  levelCounters: {
    [key: string]: number;
  };
  productCounters: {
    [key: string]: number;
  };
  deploymentCounters: {
    [key: string]: number;
  };
  userRolesCounters: {
    [key: string]: number;
  };
}

export const getAtlenzCatalogResourcesCount = async (
  filters: Record<string, string[]>,
  searchValue?: string,
): Promise<AtlenzCountersResponse | null> => {
  const body = {
    pagination: {
      from: 0,
      size: 0,
    },
    ...filters,
    searchValue,
  };

  try {
    const response = await fetch(`${globalThis.location.origin}/gateway/api/learning-app/search/counters`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    return response.json();
  } catch (error) {
    return null;
  }
};
